import * as React from 'react'

function SvgOrdersIcon(props) {
  return (
    <svg
      width="2em"
      height="2em"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={32} height={31} rx={10} fill="#fff" />
      <path
        d="M18 10.823v-.004l2.994 1.357L24 11.036 16 8l-8 3.036 8 3.035 2.994-1.136L16 11.686v-.003l2-.86zM8 12.047v9.107L15.5 24v-9.106L8 12.047zm4 9.14l-2-.759v-1.08l2 .76v1.08zM21 13.186v2.534l-2 .76v-2.536l-2.5.95V24l7.5-2.846v-9.107l-3 1.139z"
        fill="#FE7D11"
      />
    </svg>
  )
}

export default SvgOrdersIcon
